module.exports = __webpack_public_path__ + "img/sale-pic.2cfc1568.png";